export default __webpack_public_path__ + "static/icon-34-2-9ca1923368a99eadf44a4cb21fb4a744.png";